import { Directive, HostBinding, Input } from '@angular/core';

import { CssUtils } from '@hdms/shared/util-core';

export enum HrVerticalAlign {
  TOP = 'top',
  CENTER = 'center',
  BOTTOM = 'bottom'
}

@Directive({
  selector: '[shrdUicHr]'
})
export class HrDirective {
  @Input() vAlign: 'top' | 'center' | 'bottom' = HrVerticalAlign.CENTER;

  @Input()
  set lineHeight(num: number) {
    this.height = num !== 2 && num > 0 ? CssUtils.linesToRem(num) : undefined;
  }

  @HostBinding('style.height.rem') height: number;

  @HostBinding('class.mx-3') @Input() hasMargin: boolean;

  @HostBinding('class.line-top') get isTopAligned() {
    return this.vAlign === HrVerticalAlign.TOP;
  }

  @HostBinding('class.line-bottom') get isBottomAligned() {
    return this.vAlign === HrVerticalAlign.BOTTOM;
  }
}
